import React from "react";
import { Link } from 'react-router-dom';
import '../assets/Footer.css';
import footerinsta1 from '../assets/imgs/footer-insta1.webp';
import footerinsta2 from '../assets/imgs/footer-insta2.webp';
import footerinsta3 from '../assets/imgs/footer-insta3.webp';
import footerinsta4 from '../assets/imgs/footer-insta4.webp';
import footerinsta5 from '../assets/imgs/footer-insta5.webp';
import footerinsta6 from '../assets/imgs/footer-insta6.webp';
import weat from '../assets/imgs/footer-at.webp';
import expo2026 from '../assets/events/expo-jan-2026.JPG'
import newlaunch from '../assets/imgs/Banner/wecoming.webp';

const Footer = () => {
    const instaImages = [
        footerinsta1,
        footerinsta2,
        footerinsta3,
        footerinsta4,
        footerinsta5,
        footerinsta6
    ];

    return (
        <footer className="footer">
            <div className="footer-container">
                {/* About Section */}
                <div className="footer-col">
                    <h4>About</h4>
                    <p>407 Navale Icon. Navale Bridge, Vadgaon Bk - 411041, Pune, India</p>
                    <p>+91 97300 50099 / 97300 20099</p>
                    <p>sales@samriddhidevelopers.in</p>
                    <form className="email-form">
                        <input type="email" placeholder="Enter email address" />
                        <button type="submit">➤</button>
                    </form>
                </div>

                {/* Latest News */}
                <div className="footer-col">
                    <h4>Latest News</h4>
                    <div className="news-item">
                        <img src={expo2026} loading="lazy" alt="news" />
                        <div>
                            <p>Samriddhi Group at Sakal Vastu Expo - Pandit Farms, Pune</p>
                            <small>August. 22 & 23<sup>th</sup>2026</small>
                        </div>
                    </div>
                    <div className="news-item">
                        <img src={expo2026} loading="lazy" alt="news" />
                        <div>
                            <p>Samriddhi Group at Sakal Vastu Expo - Mahalaxmi Lawns Pune</p>
                            <small>April. 11 & 12<sup>th</sup>2026</small>
                        </div>
                    </div>
                    {/* <div className="news-item">
                        <img src={newlaunch} loading="lazy" alt="news" />
                        <div>
                            <p>Launching Blue Horizon @Hinjewadi Annexe</p>
                            <small>April. 09, 2025 </small>
                        </div>
                    </div> */}
                </div>
                {/* <div className="footer-col">
                    <h4>Latest News</h4>
                    <div className="news-item">
                        <img src={weat} loading="lazy" alt="news" />
                        <div>
                            <p>Samriddhi Group at Sakal Vastu Expo - Baner Pune</p>
                            <small>May. 31<sup>st</sup> & June. 01<sup>st</sup>2025</small>
                        </div>
                    </div>
                    <div className="news-item">
                        <img src={newlaunch} loading="lazy" alt="news" />
                        <div>
                            <p>Launching Blue Horizon @Hinjewadi Annexe</p>
                            <small>April. 09, 2025 </small>
                        </div>
                    </div>
                </div> */}

                {/* Information Links */}
                <div className="footer-col">
                    <h4>Information</h4>
                    <ul>
                        <li>About</li>
                        <li>Products</li>
                        <li>Blog</li>
                        <li>Contact</li>
                        <li>Help & Support</li>
                        <li><Link to="positiveleads">T.Follow Up</Link></li>
                        <li><Link to="siteVisit">S.Follow Up</Link></li>
                    </ul>
                </div>

                {/* Instagram Gallery */}
                <div className="footer-col">
                    <h4>Instagram</h4>
                    <a href="https://www.instagram.com/samriddhigroupofficial?igsh=c3dhYXFmOGJjYWlp" target="_blank" className="insta-gallery">
                        {instaImages.map((imgSrc, i) => (
                            <img key={i} src={imgSrc} loading="lazy" alt={`insta-${i + 1}`} />
                        ))}
                    </a>
                </div>
            </div>

            <div className="footer-bottom">
                <p>Copyright ©{new Date().getFullYear()} All rights reserved.</p>

                <p>samriddhidevelopers.in</p>
            </div>
        </footer>
    );
};

export default Footer;
